import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import "./App.css";
import RoutesCMS from "./CMS/RoutesCMS";
import AppMainEP from "./pages/AppMainEP";
import apiURLandKEYS from "./Services/apiURLandKEYS";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import TokenService from "./Services/TokenService";

function App() {
  useEffect(() => {
    AOS.init();
    

    const shouldContinue = TokenService.initializeTokenFromCookie();

    if (!shouldContinue) {
      return;
    }
  }, []);

  // Check if we're in a reload state and show loading if needed (fallback only)
  const isReloading = sessionStorage.getItem("tokenReloaded") === "true";

  // Show loading state during reload to prevent flash (fallback case only)
  if (isReloading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey={apiURLandKEYS.captchaKey}>
        <div>
          <AppMainEP />
          <RoutesCMS />
        </div>
      </GoogleReCaptchaProvider>
    </>
  );
}

export default App;
